import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

/** A bar stuck to the bottom of the screen within this page only: it spans the page, never the sidebar. */
export const PAGE_FOOTER_SX: SystemStyleObject<Theme> = {
  position: 'sticky',
  bottom: 0,
  zIndex: (theme) => theme.zIndex.appBar,
  bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'grey.900' : 'grey.200'),
  borderTop: 1,
  borderColor: 'divider',
  borderRadius: '4px 4px 0 0',
  boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.12)',
  px: 3,
  pb: 'env(safe-area-inset-bottom)'
};
